<template>
  <div>
    <CottiPrivacy v-if="brand === 'COTTI'"/>
    <TeacatPrivacy v-else/>
</div>
</template>

<script>
import CottiPrivacy from './components/cotti-privacy'
import TeacatPrivacy from './components/teacat-privacy'

export default {
  name: 'Privacy',
  components: {
    CottiPrivacy,
    TeacatPrivacy
  },
  data() {
    return {
      brand: ''
    }
  },
  mounted () {
    this.brand = this.$config.env.VUE_APP_BRAND
  }

}
</script>

<style scoped lang="scss">
</style>
